<template>
  <div v-if="inline" class="flex pa-0 display-field xs12 sm12">
    <span data-cy="display-label" class="darkGray--text mb-0 body-1">{{label}}</span>
    <a :href="to" v-if="isLink" class="body-1 mb-0 grey--text">{{prefix}} {{value}} {{suffix}}</a>
    <span v-else data-cy="display-value" class="body-1 mb-0 grey--text">{{prefix}} {{value}} {{suffix}}</span>
    <slot></slot>
  </div>
  <div v-else class="flex pa-0 display-field xs12 sm12">
    <p data-cy="display-label" class="darkGray--text mb-0 body-1">{{label}}</p>
    <a :href="to" data-cy="display-value" v-if="isLink"  class="body-1 mb-0 grey--text">{{prefix}} {{value}} {{suffix}}</a>
    <p v-else class="body-1 mb-0 grey--text" data-cy="display-value">{{prefix}} {{value}} {{suffix}}</p>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String
      },
      value: {},
      className: {
        default: 'xs12 sm12'
      },
      suffix: {
        type: String
      },
      prefix: {
        type: String
      },
      inline: {
        type: Boolean,
        default: false
      },
      to: {
        type: String,
        default: ''
      }
    },
    computed: {
      isLink () {
        return this.to !== ''
      }
    }
  }
</script>

<style lang="sass">
  .display-field .body-1
    word-wrap: break-word
</style>
